import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";
import { PayrollQPIPEarningsSetup } from "../../components/PayrollQPIPEarningsSetup";

export const PayrollQPIPEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll QPIP Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll QPIP Earnings", navigateTo: "/company/payrollQPIPEarnings/setup" }
      ]}
      mainContents={<PayrollQPIPEarningsSetup />}
    />
  );
};
